import { KitchenSinkRowItem } from 'store-types';

const baseLiveSlug = 'live';
export const liveRowsData = (rowsData: KitchenSinkRowItem[] = []): KitchenSinkRowItem[] => {
  const rows = rowsData ?? [];
  const liveRow = rows.filter(row => row?.slug === baseLiveSlug);
  if (liveRow.length > 0) {
    return liveRow;
  }
  return rows.filter(row =>
    (row?.slug ?? '').toLowerCase().startsWith(baseLiveSlug),
  );
};
